import { render, staticRenderFns } from "./DashboardMyOvertimeGauge.vue?vue&type=template&id=4b7ca095&scoped=true&"
import script from "./DashboardMyOvertimeGauge.vue?vue&type=script&lang=js&"
export * from "./DashboardMyOvertimeGauge.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMyOvertimeGauge.vue?vue&type=style&index=0&id=4b7ca095&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7ca095",
  null
  
)

export default component.exports